<template>
  <Modal class-name="vertical-center-modal"
         v-model="isWithdraw"
         title="用户提现">
    <div class="form-wrapper">
      <Form :model="withdrawForm"
            label-position="right"
            :label-width="100"
            :rules="ruleValidate">
        <FormItem label="真实姓名:">
          <div class="form-group">
            <Input v-model="withdrawForm.realname"
                   placeholder="请输入您的真实姓名" />
          </div>
        </FormItem>
        <FormItem label="支付宝账号:">
          <div class="form-group">
            <Input v-model="withdrawForm.alipay"
                   placeholder="请输入您的支付宝账号" />
          </div>
        </FormItem>
        <FormItem label="提现金额:">
          <div class="form-group">
            <Input v-model="withdrawForm.money"
                   placeholder="请输入您的提现金额" />
            <p style="font-size:14px">最大可提现金额：<span class="normal-font">{{info.max_withdraw_amount}}</span> 元</p>
          </div>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn cancel-btn"
              @click="handelCancel">取消</span>
        <span class="btn confirm-btn"
              @click="handelSubmit">确定</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, Form, FormItem, Input } from 'view-design'
import { alipayWithdraw } from '@/api/withdraw'
export default {
  name: "Withdraw",
  components: {
    Modal,
    Form,
    FormItem,
    Input
  },
  props: {
    info: {
      type: Object,
      default: {}  
    },
  },
  created() {
  },
  data: function () {
    return {
      isWithdraw: false,
      withdrawForm: {
        realname: '',
        alipay: '',
        money: ''
      },
      loading:false,
      ruleValidate: {}
    }
  },
  methods: {
    init: function () {
      this.isWithdraw = true
    },
    handelCancel: function () {
      this.isWithdraw = false
    },
    handelSubmit: function () {
      if(this.loading){
        return
      }
      if(!this.withdrawForm.realname){
        this.$Message.error('请填写真实姓名')
        return
      }
      if(!this.withdrawForm.alipay){
        this.$Message.error('请填写支付宝账号')
        return
      }
      if(!this.withdrawForm.money){
        this.$Message.error('请填写提现金额')
        return
      }
      this.loading = true
      alipayWithdraw(this.withdrawForm).then(response => {
        this.loading = false
        this.$Message.success(response.message)
        this.handelCancel();
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
.normal-font {
  color: #ff8622;
  font-size: 14px;
}
>>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 0;
}
>>> .form-wrapper .form-group .ivu-input:focus {
  border: 1px solid #ff8622 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  outline: none;
}
>>> .form-wrapper .form-group .ivu-input:hover {
  border-color: #ff8622;
}
>>> .vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 12px 18px 12px 18px;
  text-align: right;
}

.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.footer-wrapper .btn {
  display: inline-block;
  border-radius: 4px;
  margin-right: 10px;
  padding: 0px 15px;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  cursor: pointer;
}
.footer-wrapper .btn.confirm-btn {
  background: #ff8622;
  color: #fff;
}
.footer-wrapper .btn.cancel-btn {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  color: #222222;
}
</style>



// WEBPACK FOOTER //
// src/components/promotion/Withdraw.vue